import { useState, useEffect } from "react";
import nav from "../../data/nav.json";
import pdfResume from "../../assets/2026_Bekky_Rage_Resume_online.pdf";
import { Link as RouterLink } from "react-router-dom";

function SubNavbar() {
  const [navActive, setNavActive] = useState(false);

  const toggleNav = () => {
    setNavActive(!navActive);
  };

  const closeMenu = () => {
    setNavActive(false);
  };

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth <= 500) {
        closeMenu();
      }
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  useEffect(() => {
    if (window.innerWidth <= 1200) {
      closeMenu();
    }
  }, []);

  return (
    <nav className={`navbar ${navActive ? "active" : ""}`}>
      <div className="mainLogoWrapper">
        <div className="mainLogo">
          <a className="linkHome" href="/">
            <img src="./img/pink-bow-white-center.png" alt="Logo" />
            <code>
              {`
                {bekky.ambient.rage}
              `}
            </code>
          </a>

        </div>
      </div>
      <a className={`nav_hamburger ${navActive ? "active" : ""}`} onClick={toggleNav}>
        <span className="nav_hamburger_line"></span>
        <span className="nav_hamburger_line"></span>
        <span className="nav_hamburger_line"></span>
      </a>

      <div className={`navbar-items ${navActive ? "active" : ""}`}>
        <ul>
          {nav?.map((item, index) =>
            <li key={index}>
              {item.type === "route" ? (
                <RouterLink onClick={closeMenu} to={item.target} className="navbar-content">
                  {item.label}
                </RouterLink>
              ) : (
                <RouterLink onClick={closeMenu} to={`/#${item.target}`} className="navbar-content">
                  {item.label}
                </RouterLink>
              )}
            </li>
          )}
        </ul>
      </div>

      <a href={pdfResume} download="2026_Bekky_Rage_Resume_online.pdf" className="btn btn-outline-primary">Download Resume</a>

    </nav>
  );
}

export default SubNavbar;
